export default __webpack_public_path__ + "assets/img/ict-settings.828a774df7235142ccbd407f733a0f61.svg";